// components/aboutData.js
import seaview from "../images/garitsa-seaview.jpg";
import exterior from "../images/exterior-garitsa.jpg";

export const aboutMain = {
  image: seaview,
  subtitle: "About Mesogeios",
  title: "Mediterranean Dining Experience In Garitsa",
  paragraphs: [
    "Mesogeios combines authentic Greek hospitality with elegant modern cuisine...",
    "From seafood specialties to handcrafted cocktails..."
  ],
  ctaText: "Reserve Your Table",
  ctaLink: "/reservation",
};

export const aboutWedding = {
  image: exterior,
  subtitle: "Weddings at Mesogeios Restaurant",
  title: "A Seaside Wedding Experience",
  paragraphs: [
    "We design unforgettable wedding experiences overlooking the Ionian Sea.",
    "From ceremony to reception, everything is tailored to you.",
    "Call us directly. Let's discuss the details and let us set the vibe."
  ],
  ctaText: "Plan Your Wedding",
  ctaLink: "tel:+302661045827",
};